import * as React from 'react';

interface IPageBreakProps {
}

export const PageBreak: React.FunctionComponent<IPageBreakProps> = (props) => {
    return <div style={{ pageBreakAfter: 'always', breakAfter: 'page' }}></div>;
};
